import { render, staticRenderFns } from "./GatewayChild.vue?vue&type=template&id=fa2bfc5a&scoped=true&"
import script from "./GatewayChild.vue?vue&type=script&lang=js&"
export * from "./GatewayChild.vue?vue&type=script&lang=js&"
import style0 from "./GatewayChild.vue?vue&type=style&index=0&id=fa2bfc5a&lang=scss&scoped=true&"
import style1 from "./GatewayChild.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2bfc5a",
  null
  
)

export default component.exports